import React, { Fragment } from "react";
import { Dialog as MUIDialog, Grid, Typography, Button } from "@mui/material";

export default function RedirectDialog({ popUp, redirectURL, setPopUp }) {
  const handleClose = () => setPopUp(false);

  return (
    <MUIDialog
      open={popUp}
      onClose={handleClose}
      PaperProps={{
        sx: { minWidth: 800 }, // replaces makeStyles
      }}
    >
      <Grid container spacing={2} p={5} alignItems="center">
        <Grid item xs={9}>
          <Typography variant="h5">
            Start WhatsApp Onboarding Journey By Clicking the Button
          </Typography>
        </Grid>

        <Grid item xs={3} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            href={redirectURL}
            // target="_blank" // uncomment if you want to open in a new tab
          >
            Go To Onboarding Page
          </Button>
        </Grid>
      </Grid>
    </MUIDialog>
  );
}
